import { jsx, jsxs } from "react/jsx-runtime";
import {
  Avatar,
  Col,
  Input,
  Layout,
  List,
  Row,
  theme,
  Typography,
  Grid,
  Flex
} from "antd";
import { withScrollToTop } from "./../../hoc";
import { ReactComponent as SearchIcon } from "./../../assets/icons/search.svg";
import SearchApi from "./../../api/SearchApi.js";
import { startTransition, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  CATEGORY_EVENTS,
  CATEGORY_TO_PATH,
  SEARCH_CATEGORIES
} from "./searchService";
import { CloseOutlined } from "@ant-design/icons";
import { EVENT_ACTIONS, track } from "./../../lib/gtag.js";
import FavoritesComponent from "./../../components/favoritesComponent/FavoritesComponent.js";
import { FAVORITE_CATEGORIES } from "./../../components/favoritesComponent/favoritesService.js";
import { useTranslation } from "@inscore/shared";
const { Title, Text } = Typography;
const { Content } = Layout;
const { useBreakpoint } = Grid;
const Search = ({ isInDrawer, onFavoriteToggle }) => {
  const [query, setQuery] = useState("");
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const { token } = theme.useToken();
  const searchApi = SearchApi.search();
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const { t } = useTranslation();
  useEffect(() => {
    track(EVENT_ACTIONS.SEARCH);
  }, []);
  useEffect(() => {
    setLoading(true);
    search({ query, type: 1 });
    track(EVENT_ACTIONS.SEARCH_HIT, { value: query });
    return () => {
      searchApi.cancel();
    };
  }, [query]);
  const handleSearch = (e) => {
    startTransition(() => setQuery(e.target.value));
  };
  const search = async (params) => {
    var _a;
    try {
      const response = await searchApi.call(params);
      setData((_a = response.data) != null ? _a : {});
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const onLinkClick = (category) => {
    const event = CATEGORY_EVENTS[category];
    event && track(event);
  };
  return /* @__PURE__ */ jsx(
    Layout,
    {
      style: {
        marginBottom: isInDrawer ? 0 : 24,
        background: isInDrawer ? "transparent" : token.colorBgContainer,
        borderRadius: token.borderRadius
      },
      className: "container search-page",
      children: /* @__PURE__ */ jsxs(
        Content,
        {
          style: {
            padding: isInDrawer ? 0 : isMobile ? 16 : "24px 40px"
          },
          children: [
            !isInDrawer && /* @__PURE__ */ jsx(Title, { level: 3, style: { marginBottom: 16, marginTop: 0 }, children: t("search") }),
            /* @__PURE__ */ jsx(
              Input,
              {
                prefix: /* @__PURE__ */ jsx(SearchIcon, { className: "stroke-base" }),
                style: {
                  width: isMobile || isInDrawer ? "100%" : 408,
                  height: 56,
                  fontSize: token.fontSizeLG,
                  fontWeight: 600
                },
                onChange: handleSearch,
                onClear: () => setQuery(""),
                allowClear: {
                  clearIcon: /* @__PURE__ */ jsx(
                    CloseOutlined,
                    {
                      style: { color: token.colorTextBase }
                    }
                  )
                }
              }
            ),
            /* @__PURE__ */ jsx(
              Row,
              {
                gutter: [60, 24],
                style: { marginTop: isInDrawer ? 24 : 36 },
                children: Object.keys(data).filter((key) => data[key].length).length ? Object.keys(data).filter((key) => data[key].length).map((key) => {
                  return /* @__PURE__ */ jsxs(
                    Col,
                    {
                      xs: 24,
                      md: isInDrawer ? 24 : 12,
                      lg: isInDrawer ? 24 : 8,
                      children: [
                        /* @__PURE__ */ jsx(
                          Title,
                          {
                            level: 4,
                            style: {
                              marginBottom: 16,
                              marginTop: 0,
                              fontWeight: 500,
                              color: token.colorBlackWhite
                            },
                            children: t(key.toLowerCase())
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          List,
                          {
                            size: "large",
                            dataSource: data[key],
                            renderItem: (item) => /* @__PURE__ */ jsx(
                              List.Item,
                              {
                                style: {
                                  justifyContent: "flex-start",
                                  border: "none",
                                  padding: 0
                                },
                                children: /* @__PURE__ */ jsxs(
                                  Link,
                                  {
                                    to: `/${CATEGORY_TO_PATH[key]}/${item.id}`,
                                    style: {
                                      display: "flex",
                                      gap: 8,
                                      width: "100%",
                                      padding: isInDrawer ? 12 : "12px 24px",
                                      justifyContent: "space-between",
                                      alignItems: "center"
                                    },
                                    onClick: () => onLinkClick(key),
                                    children: [
                                      /* @__PURE__ */ jsxs(
                                        Flex,
                                        {
                                          align: "center",
                                          gap: 12,
                                          children: [
                                            /* @__PURE__ */ jsx(
                                              Avatar,
                                              {
                                                src: item.iconUrl,
                                                style: {
                                                  height: 22,
                                                  width: 22,
                                                  flexShrink: 0,
                                                  borderRadius: "50%",
                                                  backgroundColor: token.colorWhite
                                                }
                                              }
                                            ),
                                            /* @__PURE__ */ jsxs(
                                              Flex,
                                              {
                                                vertical: true,
                                                align: "start",
                                                gap: 4,
                                                children: [
                                                  /* @__PURE__ */ jsx(
                                                    Text,
                                                    {
                                                      style: {
                                                        color: token.colorTextBase,
                                                        fontWeight: 600
                                                      },
                                                      children: item.name
                                                    }
                                                  ),
                                                  /* @__PURE__ */ jsx(
                                                    Text,
                                                    {
                                                      style: {
                                                        color: token.colorTextBase,
                                                        fontWeight: 400,
                                                        fontSize: token.fontSizeXS
                                                      },
                                                      children: item.moreInfo
                                                    }
                                                  )
                                                ]
                                              }
                                            )
                                          ]
                                        }
                                      ),
                                      isInDrawer && /* @__PURE__ */ jsx(
                                        FavoritesComponent,
                                        {
                                          category: key === SEARCH_CATEGORIES.Teams ? FAVORITE_CATEGORIES.TEAM : FAVORITE_CATEGORIES.LEAGUE,
                                          itemId: item.id,
                                          isFavorite: item.isFavorite,
                                          callback: onFavoriteToggle
                                        }
                                      )
                                    ]
                                  }
                                )
                              }
                            )
                          }
                        )
                      ]
                    },
                    key
                  );
                }) : !loading && /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(Text, { children: t("no_results_suggestion") }) })
              }
            )
          ]
        }
      )
    }
  );
};
var stdin_default = withScrollToTop(Search);
export {
  stdin_default as default
};
